import { ADMIN_ROLE } from "../../Constants";
import { isObjectEmpty, log, getEncryptedUserData } from "../../services/Utils";
const { defineAbility } = require('@casl/ability');
//CASL Library
export default defineAbility((can, cannot) => {
  let user = getEncryptedUserData();
  // can('manage', 'all'); CALS
  if (!isObjectEmpty(user, 'role'))
    if (user['role'] === ADMIN_ROLE) {
      can('manage', 'all');
    } else {
      if (user !== null && Array.isArray(user['rights']) && user['rights'].length > 0) {
          for (let a = 0; a < user['rights'].length; a++) {
            let right = user['rights'][a];
            log("PERMS ZAA: ", right);
            let resource = right['resource_id'];
            if (right['resource_id'] === null || right['resource_id'] === "") {
              resource = right['id'];
            }
            can(right['action'], resource);
          }
      }
    }
});


